import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { ActiveUserMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/ActiveUsersCloums';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { CompanyCountriesShareCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CompanyCountriesShareCloums';
import { getCompanyRevenueDownloadValueOfCvm, findRevenueData } from '../_utils';

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    tabId,
    tableTotal,
    dataSource = 'appannie',
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    isGlobal,
  } = props;

  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: tabId,
    currentRatioType: 0,
  });
  const defaultPageSize = 5;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    setSortTableData(tableData);
  }, [JSON.stringify(tableData)]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e?.ratioType || 0,
    });
    onTableSortChage(e);
    // 将页码重置,与接口一至
    setPageIndex(1);
    setPageSize(defaultPageSize);
  };

  const getMetricCloums = (dataSource: string) => {
    const metricCloums: any[] = [];
    columnsList?.forEach((t: any) => {
      metricCloums.push(
        ActiveUserMetricColumn({
          isNoDropdown: t.value?.indexOf(tabId) === -1,
          dataSource: dataSource === 'ogdb' ? 'databarin' : dataSource,
          title: t.title,
          textContent: t.textContent,
          key: `${t.value}_${dataSource}`,
          sortMetric: t.value,
          currentSortValue,
          currentSortKey: `${currentSortMetric}_${dataSource}_${currentRatioType}`,
          onSortChage,
          renderType: t?.renderType,
          width: columnsList?.length === 1 ? 'auto' : t?.width,
          width_cn: columnsList?.length === 1 ? 'auto' : t?.width_cn,
          getMetricValueOfCvm: (cvm: any, sortMetric: string) => {
            const metric = findRevenueData(cvm?.markets_metrics, sortMetric, dataSource);
            return getCompanyRevenueDownloadValueOfCvm(metric);
          },
        }),
      );
    });
    return metricCloums;
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  return (
    <>
      <TopchartTable
        recordKey="app_id"
        loading={tableLoading}
        records={sortTableData}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        pageSizeOptions={[5, 10, 15]}
        className="dbi-mobileGames-details-table"
        columns={[
          CompanyCountriesShareCloums({
            countriesShareType: 'market',
            tipText: !isGlobal
              ? null
              : tabId === 'download'
              ? 'dbi_detail_download_allcountries_tip'
              : 'dbi_detail_revenue_allcountries_tip',
            firstLineName: isGlobal ? 'dbi_detail_table_allcountries' : 'dbi_detail_table_total',
          }),
          ...getMetricCloums(dataSource),
        ]}
      />
    </>
  );
};

export default TrendsCard;
